// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"bdcc2552","529":"53e4f4e6"}[chunkId] + ".chunk.js";
};